module.exports = __webpack_public_path__ + "img/info.376237a0.svg";